export default "__VITE_ASSET__DO8GktlK__"